module.exports = __webpack_public_path__ + "static/media/tiler.3c462b44.jpeg";